import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-2 order-2 text-center" }
const _hoisted_9 = {
  key: 0,
  class: "fa fa-arrow-circle-right fa-2x",
  title: "From connector to dataset"
}
const _hoisted_10 = {
  key: 1,
  class: "fa fa-arrow-circle-right fa-2x",
  title: "From dataset to connector"
}
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = { class: "row mb-1" }
const _hoisted_13 = { class: "col-2 order-2 text-center" }
const _hoisted_14 = ["onClick"]

import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminConfigurePipelineMappingsPage } from '@Integrations/Pipelines/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminConfigurePipelineMappingPage',
  setup(__props) {

    document.title = "Configure mappings"

    const tid = useOrganizationUnitId()
    const id = useId()

    const connectorId = ref()

    const idPropertyNameForConnector = ref()
    const idPropertyNameForDataset = ref()

    const idPropertyNamesForConnector = ref([])
    const idPropertyNamesForDataset = ref([])

    const nameForConnector = ref()
    const nameForDataset = ref()

    const {
        useCurrentUserQuery,
        usePipelineDetailsQuery,
        useConnectorPropertyNamesQuery,
        useAddPropertyNameMappingCommand,
        useRemovePropertyNameMappingCommand
    } = useAdminConfigurePipelineMappingsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { runPipelineDetailsQueryV1, modelPipelineDetailsQueryV1 } = usePipelineDetailsQuery(id)
    const direction = computed(() => modelPipelineDetailsQueryV1.value?.Direction)
    const properties = computed<string>(() => modelPipelineDetailsQueryV1.value?.Properties ?? [])
    const mappings = computed(() => modelPipelineDetailsQueryV1.value?.Mappings || [])

    const { dataStream, runConnectorPropertyNamesQueryV1, modelConnectorPropertyNamesQueryV1 } = useConnectorPropertyNamesQuery(connectorId)
    const propertyNames = computed(() => modelConnectorPropertyNamesQueryV1.value?.PropertyNames || [])

    const { invokeAddPropertyNameMappingCommandV1, succeedAddPropertyNameMappingCommandV1 } = useAddPropertyNameMappingCommand(id, tid, userId, nameForConnector, nameForDataset)
    const { invokeRemovePropertyNameMappingCommandV1, succeedRemovePropertyNameMappingCommandV1 } = useRemovePropertyNameMappingCommand(id, tid, userId)

    const availablePropertyNames = computed(() => properties.value.length > 0 ? properties.value : propertyNames.value)

    function handleAddPropertyNameMappingCommand() {
        invokeAddPropertyNameMappingCommandV1()
    }

    function handleRemovePropertyNameMappingCommandV1(mapping: any) {
        invokeRemovePropertyNameMappingCommandV1({
            nameForConnector: mapping.NameForConnector,
            nameForDataset: mapping.NameForDataset,
        })
    }

    watch(modelPipelineDetailsQueryV1, () => {
        connectorId.value = modelPipelineDetailsQueryV1.value.ConnectorId
        dataStream.value = modelPipelineDetailsQueryV1.value.DataStream
    })

    watch(connectorId, () => runConnectorPropertyNamesQueryV1())

    watch(succeedAddPropertyNameMappingCommandV1, () => runPipelineDetailsQueryV1())
    watch(succeedRemovePropertyNameMappingCommandV1, () => runPipelineDetailsQueryV1())

    watch(succeedAddPropertyNameMappingCommandV1, () => {
        nameForConnector.value = ''
        nameForDataset.value = ''
    })

    onMounted(() => {
        runCurrentUserQueryV1()
        runPipelineDetailsQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AdminNavigationV2, { tid: _unref(tid) }, null, 8 /* PROPS */, ["tid"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Configure mappings", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/integrations/pipelines/details/${_unref(tid)}/${_unref(id)}`,
            type: "button",
            class: "btn btn-link btn-sm"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-5 col-sm-6 text-right" }, null, -1 /* CACHED */))
      ])
    ]),
    _cache[8] || (_cache[8] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-5 text-right", { 'order-1': direction.value==1, 'order-3': direction.value==2 }])
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("h5", null, "Connector", -1 /* CACHED */)
        ]))], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_8, [
          (direction.value==1)
            ? (_openBlock(), _createElementBlock("i", _hoisted_9))
            : _createCommentVNode("v-if", true),
          (direction.value==2)
            ? (_openBlock(), _createElementBlock("i", _hoisted_10))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", { 'order-1': direction.value==2, 'order-3': direction.value==1 }])
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("h5", null, "Dataset", -1 /* CACHED */)
        ]))], 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", { 'order-1': direction.value==1, 'order-3': direction.value==2 }])
        }, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nameForConnector).value = $event)),
            class: "form-control"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availablePropertyNames.value, (p) => {
              return (_openBlock(), _createElementBlock("option", null, _toDisplayString(p), 1 /* TEXT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ], 512 /* NEED_PATCH */), [
            [
              _vModelSelect,
              nameForConnector.value,
              void 0,
              { trim: true }
            ]
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", { class: "col-2 order-2 text-center" }, [
          _createElementVNode("button", {
            onClick: handleAddPropertyNameMappingCommand,
            class: "btn bt-sm btn-secondary"
          }, "Add")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["col-5", { 'order-1': direction.value==2, 'order-3': direction.value==1 }])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nameForDataset).value = $event)),
            type: "text",
            class: "form-control"
          }, null, 512 /* NEED_PATCH */), [
            [
              _vModelText,
              nameForDataset.value,
              void 0,
              { trim: true }
            ]
          ])
        ], 2 /* CLASS */)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mappings.value, (m) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: _normalizeClass(["col-5 text-right", { 'order-1': direction.value==1, 'order-3': direction.value==2 }])
          }, [
            _createElementVNode("strong", null, _toDisplayString(m.NameForConnector), 1 /* TEXT */)
          ], 2 /* CLASS */),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              onClick: ($event: any) => (handleRemovePropertyNameMappingCommandV1(m)),
              role: "button"
            }, [...(_cache[7] || (_cache[7] = [
              _createElementVNode("i", {
                class: "fa fa-remove fg-color-red",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */)
            ]))], 8 /* PROPS */, _hoisted_14)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["col-5", { 'order-1': direction.value==2, 'order-3': direction.value==1 }])
          }, [
            _createElementVNode("strong", null, _toDisplayString(m.NameForDataset), 1 /* TEXT */)
          ], 2 /* CLASS */)
        ]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})